"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import n from "./Typography.js";
import m from "./Button.js";
import { f as h } from "./format-CsCXRleo.mjs";
const x = ({
  title: s,
  titleId: t,
  desc: i,
  descId: r,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": r,
    ...l,
    children: [
      i ? /* @__PURE__ */ e.jsx("desc", { id: r, children: i }) : null,
      s ? /* @__PURE__ */ e.jsx("title", { id: t, children: s }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M12 3v2M5.3141 7.3141 3.9 5.9m14.7859 1.4142L20.1 5.9M6 15c0-3.3137 2.6863-6 6-6s6 2.6863 6 6m4 0H2m17 4H5"
        }
      )
    ]
  }
), p = ({
  title: s,
  titleId: t,
  desc: i,
  descId: r,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": r,
    ...l,
    children: [
      i ? /* @__PURE__ */ e.jsx("desc", { id: r, children: i }) : null,
      s ? /* @__PURE__ */ e.jsx("title", { id: t, children: s }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M6.06 20.9125c1.21.55 2.75.55 3.9601 0 1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0M12 3v2m-8 8H2m4.3141-5.6859L4.9 5.9m12.7856 1.4142L19.0998 5.9M22 13h-2M7 13c0-2.7614 2.2386-5 5-5s5 2.2386 5 5M2.1001 17.4125c1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0 2.75-.55 3.96 0 2.75.55 3.96 0 2.75-.55 3.96 0"
        }
      )
    ]
  }
), u = ({
  title: s,
  titleId: t,
  desc: i,
  descId: r,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": r,
    ...l,
    children: [
      i ? /* @__PURE__ */ e.jsx("desc", { id: r, children: i }) : null,
      s ? /* @__PURE__ */ e.jsx("title", { id: t, children: s }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M12 2v2m0 16v2M4 12H2m4.3141-5.6859L4.9 4.9m12.786 1.4142L19.1001 4.9M6.3141 17.69 4.9 19.1042m12.786-1.4142 1.4142 1.4142M22 12h-2m-3 0c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
        }
      )
    ]
  }
), k = (s) => {
  const {
    selectedDate: t = /* @__PURE__ */ new Date(),
    selectedTime: i,
    onTimeSelect: r,
    hideHeading: l = !1,
    className: o
  } = s, c = [
    {
      title: "Morning",
      icon: /* @__PURE__ */ e.jsx(u, { className: "size-6 [&>path]:stroke-[2px] text-primary-main" }),
      slots: ["09:00 am", "10:00 am", "11:00 am"]
    },
    {
      title: "Afternoon",
      icon: /* @__PURE__ */ e.jsx(x, { className: "size-6 [&>path]:stroke-[2px] text-primary-main" }),
      slots: ["12:00 pm", "01:00 pm", "02:00 pm"]
    },
    {
      title: "Evening",
      icon: /* @__PURE__ */ e.jsx(p, { className: "size-6 [&>path]:stroke-[2px] text-primary-main" }),
      slots: ["03:00 pm", "04:00 pm", "05:00 pm"]
    }
  ];
  return /* @__PURE__ */ e.jsxs("div", { className: o, children: [
    !l && /* @__PURE__ */ e.jsx(n, { variant: "h3", className: "mb-6", children: h(t, "EEEE, MMMM d") }),
    /* @__PURE__ */ e.jsx("div", { className: "space-y-8", children: c.map((d) => /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2 mb-4", children: [
        d.icon,
        /* @__PURE__ */ e.jsx(n, { variant: "h4", className: "!font-regular", children: d.title })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "grid grid-cols-2 md:grid-cols-3 gap-3", children: d.slots.map((a) => /* @__PURE__ */ e.jsx(
        m,
        {
          onClick: () => r(a),
          variant: "outlined",
          fullWidth: !0,
          roundedFull: !0,
          color: i === a ? "primary" : "gray",
          size: "small",
          children: a
        },
        a
      )) })
    ] }, d.title)) })
  ] });
};
export {
  k as default
};
